import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, Trash2 } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../ui/alert-dialog';
import { haccpApi, erroreHaccp } from '../haccpApi';

// Scelta utente: si chiede conferma, poi il documento si cancella per sempre
export const EliminaDocumento = ({ documento, nome, avviso, onEliminato, testid }) => {
  const [aperto, setAperto] = useState(false);
  const [busy, setBusy] = useState(false);
  const elimina = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await haccpApi.del(`/documenti/${documento.id}`); toast.success('Documento eliminato'); setAperto(false); onEliminato(); }
    catch (err) { toast.error(erroreHaccp(err, 'Documento non eliminato')); }
    finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setAperto(true)} data-testid={testid}
        className="h-9 px-3 rounded-lg text-xs font-medium text-red-600 hover:bg-red-50 flex items-center gap-1 transition-colors"><Trash2 className="h-3.5 w-3.5" />Elimina</button>
      <AlertDialog open={aperto} onOpenChange={(o) => !busy && setAperto(o)}>
        <AlertDialogContent className="max-w-sm rounded-2xl" data-testid={`${testid}-conferma`}>
          <AlertDialogHeader>
            <AlertDialogTitle>Eliminare {nome}?</AlertDialogTitle>
            <AlertDialogDescription>Viene cancellato per sempre e non si può recuperare. {avviso}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={busy} data-testid={`${testid}-annulla`}>Annulla</AlertDialogCancel>
            <AlertDialogAction onClick={elimina} disabled={busy} className="bg-red-600 hover:bg-red-700 text-white gap-2" data-testid={`${testid}-conferma-btn`}>
              {busy && <Loader2 className="h-4 w-4 animate-spin" />}Elimina per sempre
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
